import styled from '@emotion/styled';
import { Body, Body2 } from '@ep/components/Typography';
import AsideModule from '@ep/modules/AsideModule';
import theme from '@ep/theme';
import { Gcms_Page } from '@ep/types/gatsbyTypes';
import checkEmptyTags from '@ep/utils/checkEmptyTags';
import getHtmlProp from '@ep/utils/getHtmlProp';
import React from 'react';

export interface GenericPageModuleProps {
  page: Gcms_Page;
}

const Main = styled(Body)`
  p {
    margin-bottom: 1rem;
    :empty {
      height: 0.1rem;
    }
  }

  a:link,
  a:hover,
  a:visited {
    color: ${theme.colors.epLinkBlue};
    text-decoration: underline;
  }
  a:hover {
    text-decoration: underline;
  }

  h2 {
    color: ${theme.colors.duskBlue};
    font-family: ${theme.typography.primaryFont.bold};
    margin-bottom: 1.2rem;
    padding-top: 2rem;
  }

  h1 {
    color: ${theme.colors.duskBlue};
    font-family: ${theme.typography.primaryFont.bold};
    font-size: 2.5rem;
  }

  strong {
    color: ${theme.colors.oceanBlue};
  }

  ul {
    padding: 0;
    margin-left: 1rem;
    li {
      list-style: none;
      padding-left: 2rem;
      position: relative;
      &:before {
        content: '>';
        position: absolute;
        left: 0;
        top: 0;
        color: ${theme.colors.oceanBlue};
      }
    }
  }

  ol {
    padding: 0;
    margin: 2rem;
    li {
      list-style: none;
      padding-left: 2rem;
      position: relative;
    }
  }

  li {
    margin-bottom: 0.5rem;
  }

  table {
    td {
      max-width: 20rem;
      padding: 0 2rem;
      vertical-align: top;
      img {
        display: block;
        max-width: 16rem;
        margin: 0 auto;
      }
    }
    ${theme.mediaQueries.desktop} {
      width: 100%;
    }
    ${theme.mediaQueries.mobileAndTablet} {
      table-layout: fixed;
      display: block;
      overflow-x: auto;
    }
  }
`;

const Aside = styled(Main.withComponent(Body2))`
  ${theme.mediaQueries.mobileAndTablet} {
    margin-top: 0.5rem;
    border-top: 1px solid ${theme.colors.gray};
    padding-top: 2.5rem;
  }
`;

function GenericPageModule({ page }: GenericPageModuleProps) {

  return (
    <AsideModule
      id={page.scrollToLink}
      heading={page.heading}
      main={page.body?.html ? <Main {...getHtmlProp(page.body.html)} /> : null}
      aside={
        page.sidebar &&
        checkEmptyTags(page.sidebar.html) && (
          <Aside {...getHtmlProp(page.sidebar.html)} />
        )
      }
      sidebars={page.sharedSidebar}
    />
  );
}

export default GenericPageModule;
